import { Card } from '@iwoca/orion';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import styles from './PortalTours.module.css';
import { TourSelection } from './TourSelection/TourSelection';
import { usePortalTours } from './usePortalTours.hook';

export const PortalTours = () => {
  const { tourData } = usePortalTours();
  return (
    <div className={styles.pageContent}>
      <h2 className={styles.heading}>Portal tours</h2>
      <h3 className={styles.subHeading}>
        New here? Or just want a refresher? These quick tours will help you find
        your way around, discover useful features, and get things done faster.
      </h3>
      <Card className={styles.card}>
        <p className={styles.instruction}>
          Pick a section and we'll guide you there to start the tour:
        </p>
        {tourData.map((tour) => (
          <TourSelection
            key={tour.name}
            name={tour.name}
            description={tour.description}
            onClick={tour.onClick}
          />
        ))}
      </Card>
      <p className={styles.footerText}>
        Still have questions?{' '}
        <Link className={styles.link} to={PATH_NAMES.faqs()}>
          Check out our FAQs
        </Link>{' '}
        for more.
      </p>
    </div>
  );
};
